import React, { useEffect, useState, useRef } from "react";
import "./FilesAndBoxes.css";
import Navbar from "../Navbar/Navbar";
import svg from "../Images/phoneicon.png";
import Footer from "../Navbar/Footer";
import { searchBoxByLocation, searchFileBox } from "../../api";
import { debounce } from "lodash";
import axios from "axios";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

function FilesAndBoxes() {
  const [searchTerm, setSearchTerm] = useState("");
  const [displayTerm, setDisplayTerm] = useState(""); // For controlling the input value
  const [searchMode1, setSearchMode1] = useState(true);
  const [searchMode2, setSearchMode2] = useState(false);
  const [searchMode3, setSearchMode3] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const searchInputRef = useRef(null);
  const [total, setTotal] = useState(0);
  const [totalFile, setTotalFiles] = useState(0);

  // Create debounced search handler that properly uses lodash debounce
  const debouncedSetSearchTerm = debounce((value) => {
    setSearchTerm(value);
  }, 500);

  const handleSearchTerm = (e) => {
    const value = e.target.value;
    setDisplayTerm(value); // Update display immediately
    debouncedSetSearchTerm(value); // Debounce the actual search
  };

  let cancelTokenSource = null;

  const handleSearch = async () => {
    // Cancel previous request if it exists
    if (cancelTokenSource) {
      cancelTokenSource.cancel("Operation canceled due to new request.");
    }

    // Create a new CancelToken
    cancelTokenSource = axios.CancelToken.source();

    const commonParams = {
      custId: localStorage.getItem("CUST_ID"),
      search: searchTerm,
      whName: localStorage.getItem("Warehouse_ID"),
      cancelToken: cancelTokenSource.token,
    };

    try {
      // const isBox = searchMode1;
      const isBox = searchMode1;
      const isLocation = searchMode3;
      if (isLocation) {
        handleSearchByLocation(searchTerm);
        return;
      }

      const data = await searchFileBox({ ...commonParams, isBox });

      if (data && Array.isArray(data.data) && data.data.length > 0) {
        setFilteredData(data.data);
        setTotal(data.total ?? 0);
      } else {
        // Show appropriate SweetAlert based on search mode
        const entityType = isBox ? "Box" : "File";
        Swal.fire({
          title: `No ${entityType} Found!`,
          text: "Please try a different search term",
          icon: "info",
          confirmButtonText: "OK",
        });
        setFilteredData([]);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log("Request cancelled:", err.message);
      } else {
        console.error("Search failed:", err);
        Swal.fire({
          title: "Search Error",
          text: "An error occurred while searching. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  const handleSearchByLocation = async (locationTerm) => {
    try {
      const response = await searchBoxByLocation({
        custId: localStorage.getItem("CUST_ID"),
        search: locationTerm,
        whName: localStorage.getItem("Warehouse_ID"),
      });

      console.log("this is data", response);
      if (Array.isArray(response) && response.length > 0) {
        const cleanedResponse = response.filter(Boolean); // removes undefined/null items

        const mappedData = cleanedResponse.map((item) => ({
          "Box No": item["Box No"] || "N/A",
          "Customer Name": item["Customer Name"] || "N/A",
          Department: item["Department"] || "N/A",
          "File Name": item["File Name"] || "N/A",
          "File No": item["File newxo"] || "N/A",
          "Item Location": item["Item Location"] || "N/A",
          Year: item["Year"] || "N/A",
        }));

        setFilteredData((prevData) => [...prevData, ...mappedData]);

        setTotal(cleanedResponse[0]["Total Boxes"] || 0);
        setTotalFiles(cleanedResponse[0]["Total Files"] || 0); // make sure this key exists
      } else {
        Swal.fire({
          title: "No Location Data Found!",
          text: "Try another location.",
          icon: "info",
          confirmButtonText: "OK",
        });
        setFilteredData([]);
      }
    } catch (err) {
      console.error("Location search failed:", err);
      Swal.fire({
        title: "Search Error",
        text: "Something went wrong while searching by location.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const fileName = `${searchMode1 ? "BoxExport" : "FileExport"}_${searchTerm}`;

  const exportToExcel = ({ data, fileName }) => {
    // 1. Convert JSON to worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // 2. Create a new workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // 3. Export to Excel file
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  useEffect(() => {
    if (searchTerm.length >= 3) {
      handleSearch();
    } else if (searchTerm.length > 0 && searchTerm.length < 3) {
      // Optional: Give feedback about minimum search length
      setFilteredData([]);
    }
  }, [searchTerm]);

  const handleCheckboxChange = (mode) => {
    setFilteredData([]);
    setSearchTerm("");
    setDisplayTerm("");
    setTotal(0);
    setTotalFiles(0);
    if (mode === "mode1") {
      setSearchMode1(true);
      setSearchMode2(false);
      setSearchMode3(false);
    } else if (mode === "mode2") {
      setSearchMode1(false);
      setSearchMode2(true);
      setSearchMode3(false);
    } else if (mode === "mode3") {
      setSearchMode1(false);
      setSearchMode2(false);
      setSearchMode3(true);
    }

    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  };

  return (
    <>
      <div style={{ maxHeight: "70vh" }} className="generatorlogcontainer">
        <Navbar />
        <div className="rec_retrival">
          <div className="svg_div">
            <img src={svg} alt="Dox and Box Backend" />
            <h2>Search Files and Boxes</h2>
          </div>

          <div
            // className="container"

            style={{
              overflow: "auto",
              width: "100%",
              maxWidth: "1000px",
              margin: "20px auto",
              padding: "20px",
              background: "white",
              height: "80vh",
              borderRadius: "10px",
            }}
          >
            <div className="controls">
              <div className="checkboxes">
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    marginBottom: "20px",
                    flexWrap: "wrap",
                    width: "80%",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={searchMode1}
                      onChange={() => handleCheckboxChange("mode1")}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#007bff",
                      }}
                    />
                    Search by Boxes
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={searchMode2}
                      onChange={() => handleCheckboxChange("mode2")}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#007bff",
                      }}
                    />
                    Search by Files
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={searchMode3}
                      onChange={() => handleCheckboxChange("mode3")}
                      style={{
                        width: "18px",
                        height: "18px",
                        accentColor: "#007bff",
                      }}
                    />
                    Search by Location
                  </label>
                  {filteredData.length > 0 && (
                    <button
                      onClick={() =>
                        exportToExcel({
                          data: filteredData,
                          fileName: fileName,
                        })
                      }
                      style={{
                        padding: "8px 12px",
                        fontSize: "14px",
                        cursor: "pointer",
                      }}
                    >
                      Export
                    </button>
                  )}
                </div>
              </div>

              <div style={{ display: "flex", gap: "20px" }}>
                {total > 0 && (
                  <span
                    style={{
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    {searchMode1 && `Total Files: ${total}`}
                    {searchMode2 && `Total Files: ${total}`}
                    {searchMode3 && `Total Boxes: ${total}`}
                  </span>
                )}
                {totalFile > 0 && (
                  <span
                    style={{
                      fontSize: "16px",
                      color: "#333",
                    }}
                  >
                    {searchMode3 && `Total Files: ${totalFile}`}
                  </span>
                )}
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <input
                  ref={searchInputRef}
                  type="text"
                  placeholder="Search... (min 3 characters)"
                  value={displayTerm}
                  onChange={handleSearchTerm}
                  style={{
                    padding: "8px",
                    fontSize: "14px",
                    marginTop: "9px",
                  }}
                />
              </div>
            </div>
            <div
              style={{ overflowX: "auto", width: "100%", maxHeight: "62vh" }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: "600px",
                }}
              >
                <thead>
                  <tr>
                    {filteredData.length > 0 &&
                      Object.keys(filteredData[0]).map((key, index) => (
                        <th
                          key={index}
                          style={{
                            padding: "8px",
                            borderBottom: "1px solid #ccc",
                            textAlign: "left",
                            background: "#f9f9f9",
                          }}
                        >
                          {key}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td
                        colSpan="100%"
                        style={{ textAlign: "center", padding: "10px" }}
                      >
                        {searchTerm.length >= 3
                          ? "No data found"
                          : "Enter at least 3 characters to search"}
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((item, rowIndex) => (
                      <tr key={item.id || `row-${rowIndex}`}>
                        {Object.values(item).map((value, i) => (
                          <td
                            key={i}
                            style={{
                              padding: "8px",
                              borderBottom: "1px solid #eee",
                              textWrap: "wrap",
                            }}
                          >
                            {value}
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default FilesAndBoxes;
